import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import env from "@/helpers/env";

Vue.use(Vuetify);
console.log(env)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: env.color ? "#FF6060" : "#00AFF1",
        secondary: "#FFF",
        accent: "#403579",
        accent2: "#F1F1F2",
        error: "#FF6060",
        success: "#5AB55E",
      },
    },
  },
});
